import "../../assets/index11.css";
import { jsxs as B, jsx as f, Fragment as ae } from "react/jsx-runtime";
import { ButtonIcon as ie } from "../ButtonIcon/index.js";
import { g as ce } from "../../chunks/generate-random-id.f7e64105.js";
import { m as le } from "../../chunks/make-refs.cb0b9b76.js";
import { useEffect as k, memo as H, forwardRef as ue, useMemo as me, useRef as fe, useState as F } from "react";
import { c as C } from "../../chunks/index.80e735c1.js";
const be = "_modal_adovu_7", he = "_dismiss_adovu_50", ve = "_header_adovu_60", we = "_heading_adovu_96", _e = "_description_adovu_107", xe = "_body_adovu_111", pe = "_content_adovu_118", ge = "_footer_adovu_134", ye = "_column_adovu_139", Ee = "_side_adovu_152", Ce = "_small_adovu_177", Ne = "_large_adovu_183", Le = "_fixedFooter_adovu_188", d = {
  modal: be,
  dismiss: he,
  header: ve,
  heading: we,
  description: _e,
  body: xe,
  content: pe,
  footer: ge,
  column: ye,
  side: Ee,
  small: Ce,
  large: Ne,
  fixedFooter: Le
}, Be = ({
  className: e,
  fixedFooter: a,
  size: t,
  position: n
}) => C([d.modal, e], {
  [d.fixedFooter]: !!a,
  [d[t] || ""]: t !== "medium",
  [d[n] || ""]: n !== "center"
}), Fe = ({ bodyClassName: e }) => C(d.body, e), ke = ({
  contentClassName: e
}) => C(d.content, e), Ie = ({
  dismissClassName: e
}) => C(d.dismiss, e), Re = ({ isColumnMode: e }) => C(d.footer, {
  [d.column]: !!e
}), We = (e) => {
  if (window.innerWidth >= 768 && e) {
    const a = e.getBoundingClientRect(), t = Array.from(e.children), n = Number.parseFloat(window.getComputedStyle(e).gap || "0"), b = t.reduce((l, o) => {
      const r = o.getBoundingClientRect();
      return l + r.width;
    }, 0), x = a.width - 2 * Number.parseFloat(window.getComputedStyle(e).paddingInline);
    return b + (t.length - 1) * n > x;
  }
  return !1;
}, J = `
  a[href]:not([tabindex="-1"]),
  area[href]:not([tabindex="-1"]),
  input:not([disabled]):not([tabindex="-1"]),
  select:not([disabled]):not([tabindex="-1"]),
  textarea:not([disabled]):not([tabindex="-1"]),
  button:not([disabled]):not([tabindex="-1"]),
  iframe:not([tabindex="-1"]),
  object:not([tabindex="-1"]),
  embed:not([tabindex="-1"]),
  [contenteditable]:not([contenteditable="false"]),
  [tabindex]:not([tabindex="-1"]),
  audio[controls]:not([tabindex="-1"]),
  video[controls]:not([tabindex="-1"]),
  summary:not([tabindex="-1"]),
  svg[focusable="true"]:not([tabindex="-1"]),
  div[role="button"]:not([tabindex="-1"]),
  div[role="checkbox"]:not([tabindex="-1"]),
  div[role="link"]:not([tabindex="-1"]),
  div[role="menuitem"]:not([tabindex="-1"]),
  div[role="option"]:not([tabindex="-1"]),
  div[role="radio"]:not([tabindex="-1"]),
  div[role="switch"]:not([tabindex="-1"]),
  div[role="tab"]:not([tabindex="-1"])
`, P = (e) => Array.from(
  e.querySelectorAll(J)
), $e = ({
  isOpen: e,
  onClose: a,
  onResize: t,
  ref: n
}) => {
  k(() => {
    t();
    const b = (o) => {
      var r;
      e && o.target instanceof Node && !((r = n.current) != null && r.contains(o.target)) && a();
    }, x = (o) => {
      e && o.key === "Escape" && (o.preventDefault(), a());
    }, w = (o) => {
      var y, v;
      if (o.key !== "Tab")
        return;
      const r = document.activeElement;
      if (r.closest("video, iframe") !== null)
        return;
      o.preventDefault();
      const i = n.current ? P(n.current) : [], p = i.indexOf(r);
      if (o.shiftKey) {
        const m = p > 0 ? p - 1 : i.length - 1;
        (y = i[m]) == null || y.focus();
      } else {
        const m = p < i.length - 1 ? p + 1 : 0;
        (v = i[m]) == null || v.focus();
      }
    }, l = (o) => {
      var h, i;
      const r = o.relatedTarget;
      r && !((h = n.current) != null && h.contains(r)) && ((i = P(n.current)[0]) == null || i.focus());
    };
    return window.addEventListener("resize", t), e && (window.addEventListener("mousedown", b), window.addEventListener("focusout", l), window.addEventListener("keydown", x), window.addEventListener("keydown", w)), () => {
      window.removeEventListener("resize", t), window.removeEventListener("mousedown", b), window.removeEventListener("focusout", l), window.removeEventListener("keydown", x), window.removeEventListener("keydown", w);
    };
  }, [e, n]);
};
let _ = [];
const $ = "nds-has-modal", Te = ({
  footerRef: e,
  footerSlot: a,
  className: t
}) => /* @__PURE__ */ f("footer", { className: t, ref: e, children: a }), qe = ({
  modalDismissClasses: e,
  dismissBtn: a,
  closeBtnA11yLabel: t,
  closeBtnA11yTitle: n,
  onClick: b
}) => /* @__PURE__ */ f("div", { className: e, children: /* @__PURE__ */ f(
  ie,
  {
    ref: a,
    icon: "24/symbol/close",
    size: "small",
    "aria-label": t,
    title: n,
    onClick: b
  }
) }), Ae = H(Te), De = H(qe), Pe = ue(
  ({
    bodyClassName: e,
    contentClassName: a,
    children: t,
    className: n,
    closeBtnA11yLabel: b,
    closeBtnA11yTitle: x,
    contentSlot: w,
    description: l,
    dismissClassName: o,
    fixedFooter: r,
    footerSlot: h,
    heading: i,
    headingElement: p = "h5",
    id: y,
    isMediaModal: v = !1,
    isOpen: m = !1,
    onBeforeClose: T,
    onClose: I,
    position: Q = "center",
    size: U = "medium",
    ...X
  }, Y) => {
    const u = me(() => y || ce(), [y]), { $el: c, dismissBtn: Z } = le(Y, ["$el", "dismissBtn"]), R = fe(null), [M, ee] = F(!1), [q, A] = F(!1), [D, N] = F(m), [L, S] = F(m);
    k(() => (N(m), _ = m ? [...new Set(_.concat(u))] : _.filter((s) => s !== u), () => {
      _ = _.filter((s) => s !== u);
    }), [m]), $e({
      isOpen: q,
      ref: c,
      onClose: () => {
        _[_.length - 1] === u && N(!1);
      },
      onResize() {
        window.innerWidth >= 768 && R.current && c.current && ee(We(R.current));
      }
    });
    const j = () => document.documentElement.classList.remove($);
    k(() => {
      var s;
      if (D)
        document.documentElement.classList.add($), S(!0);
      else {
        if (T && !T())
          return N(!0), j;
        document.documentElement.classList.remove($), A(!1), (s = c.current) == null || s.addEventListener("transitionend", (E) => {
          var g, z;
          E.target === c.current && E.propertyName === "opacity" && (I == null || I(), (z = (g = c.current).close) == null || z.call(g), S(!1));
        });
      }
      return j;
    }, [D]);
    const K = () => {
      var s;
      return (s = c.current.querySelector(J)) == null ? void 0 : s.focus();
    }, G = (s) => {
      s.target === c.current && s.propertyName === "opacity" && (K(), c.current.removeEventListener(
        "transitionend",
        G
      ));
    };
    k(() => {
      var s, E;
      if (c.current && L)
        c.current.addEventListener("transitionend", G), K(), (E = (s = c.current).show) == null || E.call(s), A(!0);
      else if (!L) {
        const g = document.body.querySelector(
          `[data-controls="${u}"]`
        );
        g == null || g.focus();
      }
    }, [L]);
    const te = l || w || h, ne = Be({ className: n, fixedFooter: r, size: U, position: Q }), oe = Re({ isColumnMode: M }), se = Fe({ bodyClassName: e }), re = ke({ contentClassName: a }), de = Ie({ dismissClassName: o }), W = /* @__PURE__ */ f(
      De,
      {
        modalDismissClasses: de,
        dismissBtn: Z,
        closeBtnA11yLabel: b,
        closeBtnA11yTitle: x,
        onClick: () => N(!1)
      }
    ), O = /* @__PURE__ */ f(
      Ae,
      {
        footerRef: R,
        footerSlot: h,
        className: oe
      }
    ), V = () => /* @__PURE__ */ B(ae, { children: [
      (l || w) && /* @__PURE__ */ B("div", { className: se, children: [
        l && /* @__PURE__ */ f(
          "p",
          {
            id: `${u}-description`,
            className: d.description,
            children: l
          }
        ),
        w
      ] }),
      (!v || !r) && h && O
    ] });
    return L ? /* @__PURE__ */ B(
      "dialog",
      {
        "aria-describedby": l && `${u}-description`,
        "aria-labelledby": i && `${u}-heading`,
        "aria-modal": !0,
        className: ne,
        id: u,
        open: q,
        ref: c,
        tabIndex: -1,
        ...X,
        children: [
          v && W,
          t,
          i ? /* @__PURE__ */ B("header", { className: d.header, children: [
            /* @__PURE__ */ f(
              p,
              {
                id: `${u}-heading`,
                className: d.heading,
                children: i
              }
            ),
            !v && W
          ] }) : !v && /* @__PURE__ */ f("header", { className: d.header, children: W }),
          te ? /* @__PURE__ */ f("div", { className: re, children: V() }) : V(),
          v && r && h && O
        ]
      }
    ) : null;
  }
);
export {
  Pe as Modal
};
//# sourceMappingURL=index.js.map
